module.exports = __webpack_public_path__ + "9082ca2c1e4d3136d0283e48b8627630.png";